var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditPrivate.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditPrivate.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "visibility"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("visibility", Object.prototype.hasOwnProperty.call(kwargs, "visibility") ? kwargs["visibility"] : "");var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditPrivate\">\n        <div class=\"MemberProfileEditPrivate-body\">\n            <div class=\"MemberProfileEditPrivate-body-title\">PROFILE SETTING</div>\n            <div class=\"MemberProfileEditPrivate-body-text\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "visibility") == "public") {
t_5 += "\n                    If you make your profile public, your name and information will appear publicly on the site. You can\n                    change your profile setting at any time.\n                ";
;
}
else {
t_5 += "\n                    If you make your profile private, your name and information will not appear anywhere on the site, but you can still add yourself to the availability list and if you do, your name will appear there. You can change your profile setting at any time.\n                ";
;
}
t_5 += "\n            </div>\n        </div>\n        <div class=\"MemberProfileEditPrivate-buttons\">\n            <div class=\"MemberProfileEditPrivate-buttons-button MemberProfileEditPrivate-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditPrivate-buttons-button MemberProfileEditPrivate-buttons-button--save\">\n                set to ";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "visibility"), env.opts.autoescape);
t_5 += "\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditPrivate");
context.setVariable("MemberProfileEditPrivate", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditPrivate.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPrivate.jinja
// module id = 118
// module chunks = 0